import React from "react";
import { SideMenuArrowContext } from "./SideMenuCloseArrow";
const RoutesWithSideMenu: React.FC = ({ children }) => {
  const [isSideMenuOpen, setSideMenuOpen] = React.useState(true);
  const toggleSideMenuOpen = () => {
    setSideMenuOpen(!isSideMenuOpen);
  };
  return (
    <SideMenuArrowContext.Provider value={{ isOpen: isSideMenuOpen, toggleOpen: toggleSideMenuOpen }}>
      {children}
    </SideMenuArrowContext.Provider>
  );
};

export default RoutesWithSideMenu;
